import React from 'react';

const tools = [
  { 
    icon: 'ri-team-line', 
    title: 'Unified Lead Management & Social Promotion', 
    description: 'Capture leads directly from social media and publish promotions across multiple platforms from a single, high-performance dashboard.', 
  },
  { 
    icon: 'ri-flight-takeoff-line', 
    title: 'One-Click Flight Price Comparison', 
    description: 'Instantly compare flight fares from top-tier global suppliers in a single click, ensuring your customers always get the most competitive rates.', 
  },
  { 
    icon: 'ri-magic-line', 
    title: 'AI-Powered Itinerary Builder', 
    description: 'Leverage the Zotrai AI to create stunning, personalized travel itineraries in under 2 minutes, reducing hours of manual work to seconds.', 
  },
  { 
    icon: 'ri-earth-line', 
    title: 'Access to 1,000+ Global DMCs', 
    description: 'Unlock direct connectivity with thousands of international DMCs to secure better inventory and exclusive pricing for your clients.', 
  },
  { 
    icon: 'ri-rocket-2-line', 
    title: 'Instant Portal Launch', 
    description: 'Launch your branded B2C, B2B, or Corporate travel portal in just a few clicks. Scale your digital presence across web and mobile instantly.', 
  },
  { 
    icon: 'ri-plug-2-line', 
    title: 'Single-Click Supplier Integration', 
    description: 'Go live instantly with industry leaders like TBO, TripJack, Riya, AirIQ, and more through our seamless API connectivity layer.', 
  },
  { 
    icon: 'ri-calculator-line', 
    title: 'Smart Travel Accounting System', 
    description: 'An end-to-end financial ecosystem covering invoicing, supplier payments, ledgers, and comprehensive financial reporting for your business.', 
  },
  { 
    icon: 'ri-layout-grid-line', 
    title: 'All-in-One Travel CRM', 
    description: 'A massive ecosystem covering Flights, Hotels, Buses, Sightseeing, Transfers, Holiday Packages, Visas, and exclusive Series Fares.', 
  },
];

export default function FeaturesPage() {
  return (
    <div style={{ backgroundColor: '#ffffff', fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}>
      
      {/* --- PREMIUM HERO SECTION --- */}
      <section className="py-3" style={{ 
        background: 'radial-gradient(at top right, #e0e7ff 0%, #ffffff 50%), radial-gradient(at bottom left, #f1f5f9 0%, #ffffff 50%)',
        paddingTop: '100px !important',
        paddingBottom: '80px !important'
      }}>
        <div className="container text-center">
            <span className="badge rounded-pill mb-3 px-3 py-2" style={{ backgroundColor: '#eef4ff', color: '#0d6efd', fontWeight: '700', letterSpacing: '1px' }}>
                <i className="ri-shield-flash-line me-2"></i> POWERED BY <span style={{color: '#003285'}}>SAAR DEVELOPERS CODE PRIVATE LIMITED</span>
            </span>
            <h1 className="display-3 fw-bold mb-4" style={{ letterSpacing: '-2px', color: '#0f172a' }}>
                The <span className="brand-highlight-blue">Zotrai</span> Toolkit.
            </h1>
            <p className="lead text-muted mx-auto" style={{ maxWidth: '750px', fontSize: '1.25rem' }}>
                A complete ecosystem of intelligent tools designed by <span className="fw-bold text-dark">Developers Code</span> to automate, scale, and dominate the travel market.
            </p>
        </div>
      </section>

      {/* --- FEATURES GRID --- */}
      <section className="py-5" style={{ backgroundColor: '#ffffff' }}>
        <div className="container pb-5">
            <div className="row g-4">
                {tools.map((tool, index) => (
                    <div className="col-lg-6" key={index}>
                        <div className="feature-card-premium h-100 p-4 border rounded-5 transition-all shadow-sm">
                            <div className="d-flex align-items-start">
                                <div className="flex-shrink-0 me-4">
                                    <div className="icon-box-glass">
                                        <i className={`${tool.icon} fs-2`}></i>
                                    </div>
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fw-bold mb-2 text-dark" style={{ letterSpacing: '-0.5px' }}>{tool.title}</h5>
                                    <p className="text-muted lh-base mb-0" style={{ fontSize: '0.95rem' }}>{tool.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
      </section>

      {/* --- CALL TO ACTION --- */}
      <section className="py-5 bg-dark rounded-5 mx-lg-4 mb-5 text-center text-white shadow-lg overflow-hidden position-relative">
          <div className="position-relative" style={{ zIndex: 2 }}>
              <h2 className="display-5 fw-bold mb-4 text-white">Ready to Transform Your Agency?</h2>
              <p className="lead opacity-75 mb-5 text-white">Join hundreds of agents already scaling with the <span className="text-primary fw-bold">Zotrai</span> ecosystem.</p>
              <a href="/register" className="btn btn-lg btn-primary rounded-5 px-4 py-3 fw-bold shadow-sm">Get Started with Zotrai</a>
          </div>
          {/* Subtle Glow Background */}
          <div className="cta-glow"></div>
      </section>

      <style dangerouslySetInnerHTML={{ __html: `
        .brand-highlight-blue {
            background: linear-gradient(120deg, #0d6efd 0%, #001f54 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-weight: 800;
        }

        .feature-card-premium {
            background-color: #ffffff;
            border-color: #f1f5f9 !important;
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
        }

        .feature-card-premium:hover {
            transform: translateY(-8px);
            border-color: #0d6efd !important;
            box-shadow: 0 20px 40px rgba(13, 110, 253, 0.1) !important;
            background-color: #fcfdff;
        }

        .icon-box-glass {
            width: 70px;
            height: 70px;
            background: #f0f7ff;
            color: #0d6efd;
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
            box-shadow: 0 10px 20px rgba(13, 110, 253, 0.05);
        }

        .feature-card-premium:hover .icon-box-glass {
            background: #0d6efd;
            color: #ffffff;
            transform: rotate(5deg) scale(1.05);
            box-shadow: 0 10px 20px rgba(13, 110, 253, 0.2);
        }

        .cta-glow {
            position: absolute;
            top: 50%; left: 50%; width: 400px; height: 400px;
            background: rgba(37, 99, 235, 0.2);
            filter: blur(100px);
            border-radius: 50%;
            transform: translate(-50%, -50%);
            pointer-events: none;
        }

        .rounded-5 { border-radius: 2rem !important; }
        .transition-all { transition: all 0.3s ease-in-out; }
      `}} />
    </div>
  );
}